import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import "./StatsSection.css";
import bgImage from "../assets/images/fachada.jpg"; // Fondo de  sección

const StatsSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, 
    threshold: 0.3,    
  });

  return (
    <section
      ref={ref}
      className="stats-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay" />
      <div className="stats-content">
        <h2>Excelencia en Números:</h2>

        <div className="stats-grid">
          <div className="stat">
            <h3>
              {inView && <CountUp end={1980} duration={2} />}
            </h3>
            <p>Fundado en</p>
          </div>

          <div className="stat">
            <h3>
              {inView && <CountUp end={1200} duration={2.5} />}
            </h3>
            <p>Estudiantes matriculados 2025</p>
          </div>

          <div className="stat">
            <h3>
              {inView && <CountUp end={107} duration={2} />}+
            </h3>
            <p>Docentes especializados</p>
          </div>

          <div className="stat">
            <h3>
              {inView && <CountUp end={50} duration={2} />}+
            </h3>
            <p>Titulados año 2025</p>
          </div>

          <div className="stat">
            <h3>
              {inView && <CountUp end={12300} duration={3} />}+
            </h3>
            <p>Egresados</p>
          </div>
          <div className="stat">
            <h3>
              {inView && <CountUp end={8} duration={5} />}+
            </h3>
            <p>Programa de estudios</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
